import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ExpandTextDirective} from './expand-text/expand-text.directive';
import {NzTableHeaderStyleDirective} from './nz-table-header-style/nz-table-header-style.directive';
import {NgAutofocusDirective} from './ng-autofocus/ng-autofocus.directive';

@NgModule({
  declarations: [
    ExpandTextDirective,
    NzTableHeaderStyleDirective,
    NgAutofocusDirective
  ],
  imports: [CommonModule],
  exports: [
    ExpandTextDirective,
    NzTableHeaderStyleDirective,
    NgAutofocusDirective
  ],
})
export class DirectivesModule { }
